<div>
    <div class="data-privacy__header">
        <div class="data-privacy__heading">
            <h1 class="data-privacy__title">Your data</h1>
        </div>
    </div>

    <div class="data-privacy__section">
        <h2 class="data-privacy__subtitle">Download your data</h2>
        <p>Get a copy of the personal data OwlHub holds about you</p>
        <lib-button color="primary" mat-button (click)="exportData()" [disabled]="exporting">
            {{ exporting ? 'Preparing...' : 'Download my data' }}
        </lib-button>
    </div>

    @if (!person_id) {
        <div class="data-privacy__section data-privacy__section--delete">
            <h2 class="data-privacy__subtitle">Delete your account</h2>
            <p>
                Your account is closed immediately and you are signed out. Your personal data, including
                your profile, assessment answers and reports, is permanently removed after 30 days.
                <strong>This cannot be undone.</strong>
            </p>
            @if (!confirming) {
                <lib-button color="accent" mat-button (click)="confirming = true">Delete my account</lib-button>
            } @else {
                <p><strong>Are you sure you want to delete your account?</strong></p>
                <lib-button color="primary" class="data-privacy__cancel" mat-button (click)="confirming = false" [disabled]="deleting">Cancel</lib-button>
                <lib-button color="accent" mat-button (click)="deleteAccount()" [disabled]="deleting">Yes, delete my account</lib-button>
            }
        </div>
    }

    @if (error) {
        <p class="data-privacy__error">{{ error }}</p>
    }
</div>
